import {
  useGetPermissionsQuery,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} from "../../infrastructure";
import type {
  CreateRolePayload,
  UpdateRolePayload,
} from "../../domain/entities/RolesPermissions";

export const usePermissions = () => {
  const queryResult = useGetPermissionsQuery();

  console.log("queryResult", queryResult); // ✅ now data will be present

  return {
    permissions: queryResult.data ?? [],
    ...queryResult,
  };
};

export const useRolesList = () => {
  const queryResult = useGetRolesQuery();
  return {
    roles: queryResult.data ?? [],
    ...queryResult,
  };
};

export const useRole = (roleId: string) => {
  const queryResult = useGetRoleByIdQuery(roleId);
  return {
    role: queryResult.data,
    ...queryResult,
  };
};

export const useCreateRole = () => {
  return useCreateRoleMutation();
};

export const useUpdateRole = () => {
  return useUpdateRoleMutation();
};

export const useDeleteRole = () => {
  return useDeleteRoleMutation();
};

export const useCreateRoleForm = () => {
  const [createRole, result] = useCreateRoleMutation();

  const create = async (payload: CreateRolePayload) => {
    return createRole(payload).unwrap();
  };

  return { create, ...result };
};

export const useUpdateRoleForm = () => {
  const [updateRole, result] = useUpdateRoleMutation();

  const update = async (roleId: string, payload: UpdateRolePayload) => {
    return updateRole({ roleId, ...payload }).unwrap();
  };

  return { update, ...result };
};

export const useDeleteRoleForm = () => {
  const [deleteRole, result] = useDeleteRoleMutation();

  const remove = async (roleId: string) => {
    return deleteRole(roleId).unwrap();
  };

  return { remove, ...result };
};
